export const BASE_URL = "https://api-v2.automemo.ro";
// export const BASE_URL = "https://automemo-api.herokuapp.com"
// export const BASE_URL = "http://127.0.0.1:8000";
// export const BASE_URL = "http://192.168.10.10:35000";
export const DATE_FORMAT = "DD-MM-YYYY";
export const SERVER_DATE_FORMAT = "YYYY-MM-DD";
export const TIME_FORMAT = "HH:mm";
export const SERVER_TIME_FORMAT = "HH:mm:ss";
export const __DEV__ = true;
export const POLL_INTERVAL = 1000 * 60 * 5;


// WEBPACK FOOTER //
// ./src/shared/constants.ts